<template>
  <el-dialog
    :visible.sync="dialogAddVisible"
    width="30%"
    :title="(editData ? '编辑' : '新建') + '菜单'"
    center
    @close="resetForm"
  >
    <el-form
      :model="form"
      label-width="100px"
      ref="addFormRef"
      :rules="addRules"
    >
      <!-- <el-form-item label="菜单描述" required prop="menuDesc">
                <el-input v-model="form.Desc" clearable ></el-input>
            </el-form-item> -->
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="url">
        <el-input v-model="form.url" clearable></el-input>
      </el-form-item>
      <el-form-item label="图标" prop="icon">
        <!-- <el-upload
                    class="avatar-uploader"
                    :action="actionUrl"
                    :limit="limit"
                    :on-success="handleAvatarSuccess"
                    :file-list="fileList"
                    list-type="picture-card">
                    <i slot="default" class="el-icon-plus"></i>
                </el-upload> -->
        <el-input v-model="form.icon" clearable></el-input>
      </el-form-item>
      <el-form-item label="排序号" prop="sortNum">
        <el-input v-model="form.sortNum" clearable type="number"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" clearable></el-input>
      </el-form-item>
      <el-form-item label="父级菜单" prop="parentMenuId">
        <el-select v-model="form.parentMenuId" placeholder="请选择" clearable>
          <el-option
            v-for="item in options"
            :key="item.menuId"
            :label="item.name"
            :value="item.menuId"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          dialogAddVisible = false;
          resetForm();
        "
        >取消</el-button
      >
      <el-button type="primary" @click="submitEdit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addMenuApi, updateMenuApi } from '@/api/user.js';
// import { image_url } from '@/utils/reqUrl'
export default {
  props: ['editData', 'options'],
  data() {
    let valid = (rule, value, callback) => {
      if (value < 0) callback(new Error('排序号必须大于0'));
      else callback();
    };
    return {
      actionUrl: '', // image_url,
      dialogAddVisible: false,
      // parentMenuId: '',
      addRules: {
        name: [{ required: true, message: '名称是必填的', trigger: 'blur' }],
        url: [{ required: true, message: '请求地址必填', trigger: 'blur' }],
        sortNum: [{ validator: valid, trigger: 'blur' }],
        icon: [{ required: true, message: '图标必填', trigger: 'blur' }],
      },
      form: {
        name: '',
        url: '',
        icon: '',
        sortNum: 0,
        parentMenuId: '',
        remark: '',
      },
      limit: 1,
      fileList: [],
    };
  },
  inject: ['reload'],
  methods: {
    resetForm() {
      this.$refs.addFormRef.resetFields();
      this.form = {};
      this.fileList = [];
    },
    handleAvatarSuccess(res) {
      this.icon = res.data.relativeFileUrl;
    },
    async submitEdit() {
      // this.form.icon = this.icon
      if (this.editData) {
        // 编辑用户
        this.editSubmit();
      } else {
        // 添加用户
        this.handleAdd();
      }
    },
    // 添加用户
    async handleAdd() {
      try {
        this.$refs.addFormRef.validate(async (valid) => {
          if (valid) {
            let res = await addMenuApi({ ...this.form });
            console.log(res);
            if (res.code === 200) {
              this.$message.success('添加成功');
              this.dialogAddVisible = false;
              this.reload();
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑用户
    async editSubmit() {
      try {
        this.$refs.addFormRef.validate(async (valid) => {
          if (valid) {
            const res = await updateMenuApi({ ...this.form });
            if (res.code === 200) {
              this.$message.success('编辑成功');
              this.dialogAddVisible = false;
              this.reload();
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
